import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const External18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H8V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V15.5C1.25 16.1904 1.80964 16.75 2.5 16.75H15.5C16.1904 16.75 16.75 16.1904 16.75 15.5V10H15.25V15.25H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M15.25 3.81053L7.51549 11.545L6.45483 10.4844L14.1892 2.75H11V1.25H16.75V7H15.25V3.81053Z'
      fill='currentColor'
    />
  </Svg>
);

External18.displayName = 'External18';
export default External18;
